jQuery(document).ready(function () {
  jQuery(".owl-carousel-testimonial").owlCarousel({
    loop: true,
    margin: 35,
    responsiveClass: true,
    nav: true,
    dots: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1,
        dots: true,
      },
      600: {
        items: 2,
        dots: true,
      },
      1280: {
        items: 3,
        dots: true,
      },
      
      1450: {
        items: 4,
        dots: true,
        autoHeight:true,
      },
    },
  });
});